import React from 'react';

export const SubTaskIcon = ({
  className,
  color,
  width,
  height,
}: {
  className?: string;
  color?: string;
  width?: number;
  height?: number;
}) => (
  <svg
    width={width ?? 24}
    height={height ?? 24}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.51116 10.6666V11.9999H13.3333V10.6666H7.51116ZM6.84449 9.33328C6.4763 9.33328 6.17783 9.63176 6.17783 9.99995V12.6666C6.17783 13.0348 6.4763 13.3333 6.84449 13.3333H14C14.3682 13.3333 14.6667 13.0348 14.6667 12.6666V9.99995C14.6667 9.63176 14.3682 9.33328 14 9.33328H6.84449Z"
      fill={color ?? 'white'}
      //stroke={color ?? 'white'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.51116 5.83373V7.16706H13.3333V5.83373H7.51116ZM6.84449 4.5004C6.4763 4.5004 6.17783 4.79887 6.17783 5.16706V7.83373C6.17783 8.20192 6.4763 8.5004 6.84449 8.5004H14C14.3682 8.5004 14.6667 8.20192 14.6667 7.83373V5.16706C14.6667 4.79887 14.3682 4.5004 14 4.5004H6.84449Z"
      fill={color ?? 'white'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.33333 2.87898C1.33333 2.51079 1.63181 2.21231 1.99999 2.21231H8C8.36819 2.21231 8.66667 2.51079 8.66667 2.87898C8.66667 3.24717 8.36819 3.54564 8 3.54564H1.99999C1.63181 3.54564 1.33333 3.24717 1.33333 2.87898Z"
      fill={color ?? 'white'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.05052 6.50041C3.05052 6.13222 3.349 5.83374 3.71719 5.83374L6.7643 5.83374C7.13249 5.83374 7.43096 6.13222 7.43096 6.50041C7.43096 6.8686 7.13249 7.16707 6.7643 7.16707L3.71719 7.16707C3.349 7.16707 3.05052 6.8686 3.05052 6.50041Z"
      fill={color ?? 'white'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.43095 11.4468C7.43095 11.815 7.13248 12.1135 6.76429 12.1135L3.66948 12.1135C3.11719 12.1135 2.66948 11.6658 2.66948 11.1135L2.66948 2.87898C2.66948 2.51079 2.96796 2.21231 3.33615 2.21231C3.70434 2.21231 4.00281 2.51079 4.00281 2.87898L4.00281 10.7802L6.76429 10.7802C7.13248 10.7802 7.43095 11.0787 7.43095 11.4468Z"
      fill={color ?? 'white'}
    />
  </svg>
);
